export default "__VITE_ASSET__l7r5OzMI__"